import { render, staticRenderFns } from "./TypeNavBar.vue?vue&type=template&id=b65435f6&scoped=true&"
import script from "./TypeNavBar.vue?vue&type=script&lang=js&"
export * from "./TypeNavBar.vue?vue&type=script&lang=js&"
import style0 from "./TypeNavBar.vue?vue&type=style&index=0&id=b65435f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65435f6",
  null
  
)

export default component.exports